/* eslint-disable max-lines-per-function */
import React from 'react'
import { useHookstate } from '@hookstate/core'
import { Grid } from '@mui/material'

import useUserState from '~/features/User/stores/UserState'

import NewSurveillanceReporting from './components/NewSurveillanceReporting'

export default function VideoMonitoringForm() {
  const { verifyPermission } = useUserState()
  const invalidRequest = useHookstate(false)

  return (
    <Grid
      container
      direction="row"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        paddingBottom: 2,
      }}
    >
      {verifyPermission(['video_surveillance_create']) && (
        <Grid item xs={12}>
          <NewSurveillanceReporting invalidRequest={invalidRequest} />
        </Grid>
      )}
    </Grid>
  )
}
